import parsePhoneNumberFromString, { AsYouType } from "libphonenumber-js";
import moment from "moment";
import { t } from "i18next";

export const reformatDate = (
  date: string | undefined,
  originalFormat: string,
  newFormat: string
) => moment(date, originalFormat).format(newFormat);

export const redirect = (target: string) => {
  window.location.assign(target);
};

export const capitalizeFirst = (str: string): string => {
  if (typeof str === "string" && str.length > 0) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  } else {
    return "";
  }
};

export const adult = (birthDate: string) => {
  if (birthDate.length >= 8 && birthDate.length <= 10) {
    const splitDate = birthDate.split("/");

    if (splitDate.length === 3) {
      if (
        parseInt(splitDate[0]) >= 1 &&
        parseInt(splitDate[0]) <= 31 &&
        parseInt(splitDate[1]) >= 1 &&
        parseInt(splitDate[1]) <= 12 &&
        parseInt(splitDate[2]) >= 1900 &&
        parseInt(splitDate[2]) <= 2099
      ) {
        const today = new Date();

        const year =
          parseInt(today.getFullYear().toString()) - parseInt(splitDate[2]);

        if (year > 18) {
          return true;
        } else if (year < 18) {
          return false;
        } else if (
          parseInt(splitDate[1]) >
          parseInt(today.getMonth().toString()) + 1
        ) {
          return false;
        } else if (
          parseInt(splitDate[1]) <
          parseInt(today.getMonth().toString()) + 1
        ) {
          return true;
        } else if (
          parseInt(today.getDate().toString()) < parseInt(splitDate[0])
        ) {
          return false;
        } else {
          return true;
        }
      }
    }
  }
  return false;
};

export const workingAge = (birthDate: string) => {
  if (birthDate.length >= 8 && birthDate.length <= 10) {
    const splitDate = birthDate.split("/");

    if (splitDate.length === 3) {
      if (
        parseInt(splitDate[0]) >= 1 &&
        parseInt(splitDate[0]) <= 31 &&
        parseInt(splitDate[1]) >= 1 &&
        parseInt(splitDate[1]) <= 12 &&
        parseInt(splitDate[2]) >= 1900 &&
        parseInt(splitDate[2]) <= 2099
      ) {
        const today = new Date();

        const year =
          parseInt(today.getFullYear().toString()) - parseInt(splitDate[2]);

        if (year > 18 && year < 65) {
          return true;
        } else if (year < 18 || year > 65) {
          return false;
        } else if (
          (year === 18 &&
            parseInt(splitDate[1]) >
              parseInt(today.getMonth().toString()) + 1) ||
          (year === 65 &&
            parseInt(splitDate[1]) < parseInt(today.getMonth().toString()) + 1)
        ) {
          return false;
        } else if (
          (year === 18 &&
            parseInt(splitDate[1]) <
              parseInt(today.getMonth().toString()) + 1) ||
          (year === 65 &&
            parseInt(splitDate[1]) > parseInt(today.getMonth().toString()) + 1)
        ) {
          return true;
        } else if (
          (year === 18 &&
            parseInt(today.getDate().toString()) < parseInt(splitDate[0])) ||
          (year === 65 &&
            parseInt(today.getDate().toString()) > parseInt(splitDate[0]))
        ) {
          return false;
        } else {
          return true;
        }
      }
    }
  }
  return false;
};

export const phoneIsValid = (phoneNumber: string, country: any) => {
  if (country === "CH" && phoneNumber.startsWith("0")) {
    return t`errors.input.leadingZeroNotAllowed`;
  }

  const phone = parsePhoneNumberFromString(phoneNumber, country);
  const isValid = phone ? phone.isValid() : false;
  return isValid || t`errors.input.invalidPattern`;
};

export const parsePhoneNumber = (prefix: string, phoneNumber: string) => {
  return new AsYouType()
    .input(`${prefix}${phoneNumber}`)
    .replace(" ", "")
    .replace(new RegExp(`^\\${prefix}\\s?`), "");
};
